import { NavigationGuardNext, Route } from 'vue-router';

import { LIST_PERMISSION } from '@/constant/ListPermission';

import Permission from './index';

import { NAME_ROUTES_DASHBOARD } from '../../routes/Dashboard';

export function permissionHelp(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();
  const verifyPermission = PermissionClass.can(LIST_PERMISSION.HELP);

  if (!verifyPermission) {
    next({
      name: NAME_ROUTES_DASHBOARD.DASHBOARD
    });
  }

  next();
}

export function permissionHelpButtonPDF() {
  const PermissionClass = new Permission();
  const verifyPermission = PermissionClass.can(LIST_PERMISSION.HELP_BUTTON_PDF);

  if (!verifyPermission) {
    return false;
  }

  return true;
}
